module.exports = __webpack_public_path__ + "static/media/31_JessicaSoyk_webfinal.23253128.jpg";